import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import { PageSection } from 'reaxl';
import { DelayedImpressionObserver, sendImpressions } from 'reaxl-analytics';
import { EmailCTA } from 'reaxl-email';
import { HomeServices, HomeServicesItemCard } from 'reaxl-home-services';

import { vdpResultsDuck } from '@/ducks/vdp';

// **************************************************************
// HomeServicesContainer:
// A UI component that allows users to select a service to enroll
// into (virtual tour, test drive, or vehicle delivery) based on
// what services are availiable from the owner
// **************************************************************

const servicesWithCTAsKeys = ['virtualTour', 'testDrive', 'vehicleDelivery'];
const homeServicesKeys = ['virtualTour', 'testDrive', 'vehicleDelivery'];

const getEmailCTA = (service, onEmailCTAClick, listingId, hideEmailForm) => {

    if (!servicesWithCTAsKeys.includes(service) || hideEmailForm) {
        return null;
    }
    // TODO home service email form checkbox not checked
    return (
        <EmailCTA
            className="display-inline-block"
            type="link-decorated"
            key={`email-${service}`}
            labelKey={service}
            onClick={onEmailCTAClick}
            listingId={listingId}
        />
    );
};

function HomeServicesContainer({
    onEmailCTAClick,
}) {
    const {
        accelerate,
        id: listingId,
        marketExtension: {
            description, programDetails, isMarketExtListing,
        } = {},
        owner: {
            hideEmailForm,
            homeServices = {},
        } = {},
    } = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);

    const isHomeServices = !!Object.keys(homeServices).filter((key) => homeServices[key]).length;
    if (!isHomeServices && !isMarketExtListing && !accelerate) {
        return null;
    }
    const services = homeServices;
    const availableServices = homeServicesKeys.filter((key) => (services[key]));

    // in case has online paperwork
    if (accelerate && !availableServices.includes('accelerate')) {
        availableServices.push('accelerate');
    }

    if (!isHomeServices && isMarketExtListing) {
        availableServices.push('vehicleDelivery');
    }
    let customServiceContent = {};
    if (isMarketExtListing) {
        customServiceContent = {
            vehicleDelivery: {
                ...(programDetails && { content: programDetails }),
                ...(description && { title: description }),
            },
        };
    }

    const servicesWithCTAs = {};
    availableServices.forEach((service) => {
        servicesWithCTAs[service] = getEmailCTA(service, onEmailCTAClick, listingId, hideEmailForm);
    });
    const handleImpression = () => {
        if (isHomeServices) {
            sendImpressions({
                name: 'dhsImpressions',
                data: {
                    inventoryId: listingId,
                },
            });
        }
    };

    /**
     * HomeServices include accelerate
     * incase isHomeService -> render <HomeServices />
     * incase !isHomeService and have market extension -> render <HomeServicesItemCard />
     */
    return (
        <PageSection className="col-lg-8">
            {(isHomeServices || accelerate) && (
                <DelayedImpressionObserver
                    onChange={handleImpression}
                    key={`homeServices-${listingId}-delayed-impression-observer`}
                >
                    <div>
                        <HomeServices
                            id="homeServices"
                            heading="We're bringing the dealership to you"
                            services={servicesWithCTAs}
                            customServiceContent={customServiceContent}
                        />
                    </div>
                </DelayedImpressionObserver>
            )}

            {(!isHomeServices && !accelerate) && isMarketExtListing && (
                <HomeServicesItemCard
                    id="marketExtension"
                    className="text-left"
                    services={servicesWithCTAs}
                    customServiceContent={customServiceContent}
                />
            )}
        </PageSection>
    );
}

export default memo(HomeServicesContainer);
